import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import YearChooser, {direction, getCurrentYear} from "../Common/YearChooser";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import VacationList from "./VacationList";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import ReportPlaceholder from "../Common/ReportPlaceholder";
import i18next from "i18next";

class Vacation extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentYear: getCurrentYear(),
            inOperation: true,
            leftDays: ""
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            this.key = {"NumYear": this.state.currentYear};
            await this.props.dispatch(this.props.holidayListSumForPO.execute(this.key, {withStyle: true}));
            await this.props.dispatch(this.props.holidayListFactForPO.execute(this.key, {withStyle: true}));
            await this.props.dispatch(this.props.holidayPeriodsListUnuseForPO.execute(Object.assign({}, this.key, {"IsViewSum": 1}), {withStyle: true}));
            await this.props.dispatch(this.props.holidayAppList.execute(this.key, {withStyle: true}));

            this.getLeftDays();
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({inOperation: false});
        }
    }

    getLeftDays = () => {
        const dt = this.props.holidayPeriodsListUnuseForPO.dataTable();
        const row = dt.find(val => val.HolidayPeriodsId === 0);

        if (row) {
            this.setState({leftDays: i18next.t("Vacation_TotalBalance", {days: textUtils.pluralize_i18next(row.DaysSumView, "daysCountPostfix")})});
        }
    }

    changeYear = (year) => {
        this.setState({currentYear: Number.parseInt(year), inOperation: true}, this.initialize)
    }

    renderSumVac = () => {
        return (<PlaceholderWrapper placeholderId="5"
                                    title={i18next.t("VacationsToBeProvided", {year: this.state.currentYear})}
                                    staticTitle={i18next.t("VacationsToBeProvided", {year: ""})}
                                    showSplitterLine={true}>
            <GridView dataItem={this.props.holidayListSumForPO} useItemStyle/>
        </PlaceholderWrapper>);
    }

    renderYearFactVac = () => {
        if (this.props.holidayListFactForPO.rowsCount() === 0)
            return (
                <div className="my-3"><strong>{i18next.t("VacationsNotFound", {year: this.state.currentYear})}</strong>
                </div>);

        return (<>
            <GridView dataItem={this.props.holidayListFactForPO} useItemStyle/>
        </>)
    }

    renderYearUnusedVac = () => {
        return (<>
            <GridView dataItem={this.props.holidayPeriodsListUnuseForPO} useItemStyle/>
        </>)
    }

    renderReport = () => {
        return (
            <ReportPlaceholder reportKey="PersHldNotUseLK" reportId="PersHldNotUseLK" title={i18next.t("ExportToExcel")}>
                {(reportParamsItem, build) => {
                    return (
                        <>
                            <button className="btn mn-btn-link" onClick={async (e) => {
                                e.preventDefault();
                                //await this.props.dispatch(reportParamsItem.setField(0, "TabNum", "10001"));
                                await build();
                            }}>
                                {i18next.t("ExportToExcel")}
                            </button>
                        </>
                    );
                }}
            </ReportPlaceholder>
        );
    };

    render() {
        return (
            <React.Fragment>
                <PlaceholderWrapper placeholderId="10" title={i18next.t("Vacations")} showSplitterLine={false}
                                    canCollapse={false}>
                    <YearChooser currentYear={this.state.currentYear}
                                 changeYear={this.changeYear} order={direction.Desc} label={i18next.t("VacationsFor")}/>
                </PlaceholderWrapper>
                {/*this.props.workplaceType === WorkplaceTypes.Baltika && */ this.renderSumVac()}
                <PlaceholderWrapper placeholderId="20" collapsed
                                    title={i18next.t("ProvidedVacationDays", {year: this.state.currentYear})}
                                    staticTitle={i18next.t("ProvidedVacationDays", {year: ""})}
                                    showSplitterLine={false}>
                    {this.renderYearFactVac()}
                </PlaceholderWrapper>
                {this.props.showVacationList &&
                    <PlaceholderWrapper placeholderId="30" title={i18next.t("YourVacationStatements")}>
                        <VacationList vacationListItem={this.props.holidayAppList}/>
                    </PlaceholderWrapper>
                }
                {/*{(this.props.workplaceType === WorkplaceTypes.Baltika || this.props.workplaceType === WorkplaceTypes.Alivaria) &&*/}
                <PlaceholderWrapper placeholderId="40" collapsed
                                    title={i18next.t("ViewRestOfVacation", {leftDays: this.state.leftDays})}
                                    showSplitterLine={false}>
                    <div>{this.renderYearUnusedVac()}</div>
                </PlaceholderWrapper>
                {/*}*/}
                <PlaceholderWrapper placeholderId="50" showSplitterLine={false} canCollapse={false}
                                    title={i18next.t("Export")}>
                    {this.renderReport()}
                </PlaceholderWrapper>
            </React.Fragment>)
    }
}

Vacation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    holidayListSumForPO: PropTypes.object,
    holidayListFactForPO: PropTypes.object,
    holidayPeriodsListUnuseForPO: PropTypes.object,
    holidayAppList: PropTypes.object,
    workplaceType: PropTypes.string,
    showVacationList: PropTypes.bool
};


Vacation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        holidayListSumForPO: state.vacationState.HolidayListSumForPO,
        holidayListFactForPO: state.vacationState.HolidayListFactForPO,
        holidayPeriodsListUnuseForPO: state.vacationState.HolidayPeriodsListUnuseForPO,
        holidayAppList: state.vacationState.HolidayAppList,
        workplaceType: state.appState.appParams.workplaceType,
        showVacationList: state.appState.appParams.showVacationList
    }
}

export default connect(mapStateToProps)(Vacation)